import React from "react";
import { motion } from "framer-motion";
import { Scale, Hotel } from "lucide-react";
import { Reveal, Eyebrow, EASE } from "./shared";

const CARDS = [
  {
    slug: "regulated",
    icon: Scale,
    title: "Regulated Consumer Markets",
    text: "Operating in categories shaped by licensing, compliance and regional regulation — where long-term relationships and disciplined execution matter more than speed.",
  },
  {
    slug: "hospitality",
    icon: Hotel,
    title: "Hospitality",
    text: "Building hospitality ventures rooted in place — spaces and experiences designed around the character of the region, built for the long run.",
  },
];

export const WhereWeFocus = () => {
  return (
    <section
      id="focus"
      data-testid="focus-section"
      className="relative py-28 lg:py-40"
      style={{ backgroundColor: "#F2F1EF" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>Where We Focus</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-bold leading-[1.08] text-3xl sm:text-4xl lg:text-5xl" style={{ color: "#2B2B2B" }}>
              Where We <span style={{ color: "#3B2C82" }}>Focus</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.slug}
                data-testid={`focus-card-${c.slug}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: i * 0.12 }}
                whileHover={{ y: -6 }}
                className="group p-8 lg:p-10 rounded-sm flex flex-col min-h-[280px] transition-colors duration-300"
                style={{ backgroundColor: "#FAF9F7", border: "1px solid #D8D8D8" }}
              >
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-sm mb-8 transition-colors duration-300"
                  style={{ border: "1px solid #D8D8D8", color: "#3B2C82" }}
                >
                  <Icon size={22} strokeWidth={1.5} />
                </div>
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-xs font-medium" style={{ color: "#8C8C8C" }}>0{i + 1}</span>
                  <h3 className="text-xl lg:text-2xl font-bold" style={{ color: "#2B2B2B" }}>{c.title}</h3>
                </div>
                <p className="text-sm lg:text-base leading-relaxed max-w-md" style={{ color: "#8C8C8C" }}>{c.text}</p>
                <span
                  className="mt-auto pt-6 h-0.5 w-0 group-hover:w-10 transition-[width] duration-500"
                  style={{ background: "#F5821F" }}
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
